var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRevenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.104,
    height: 31.59,
    viewBox: "0 0 38.104 31.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3700",
    "data-name": "Grupo 3700",
    transform: "translate(13457.354 5698.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4753",
    "data-name": "Caminho 4753",
    d: "M3.027,10.14v15.6h30.73V10.14",
    transform: "translate(-13456.551 -5693.652)",
    fill: "none",
    stroke: "#000fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1984",
    "data-name": "Ret\\xE2ngulo 1984",
    transform: "translate(-13448.641 -5682.535)",
    fill: "none",
    stroke: "#000fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.154,
    height: 12.206,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 7.654,
    height: 10.706,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1985",
    "data-name": "Ret\\xE2ngulo 1985",
    transform: "translate(-13434.4 -5682.535)",
    fill: "none",
    stroke: "#000fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.103,
    height: 6.103,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 4.603,
    height: 4.603,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_471",
    "data-name": "Caminho 471",
    d: "M5.853-.764H31.572L37.486,9.295H.883Z",
    transform: "translate(-13457.486 -5697.236)",
    fill: "none",
    stroke: "#000fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_472",
    "data-name": "Caminho 472",
    d: "M4.509,0c4-.021,4.461,4.319,4.461,4.319H0S.5.021,4.509,0Z",
    transform: "translate(-13447.539 -5683.513) rotate(180)",
    fill: "none",
    stroke: "#000fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_473",
    "data-name": "Caminho 473",
    d: "M4.509,0c4-.021,4.461,4.319,4.461,4.319H0S.5.021,4.509,0Z",
    transform: "translate(-13438.359 -5683.513) rotate(180)",
    fill: "none",
    stroke: "#000fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_474",
    "data-name": "Caminho 474",
    d: "M4.509,0c4-.021,4.461,4.319,4.461,4.319H0S.5.021,4.509,0Z",
    transform: "translate(-13429.182 -5683.513) rotate(180)",
    fill: "none",
    stroke: "#000fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_475",
    "data-name": "Caminho 475",
    d: "M4.509,0c4-.021,4.461,4.319,4.461,4.319H0S.5.021,4.509,0Z",
    transform: "translate(-13420 -5683.513) rotate(180)",
    fill: "none",
    stroke: "#000fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_7",
    "data-name": "Linha 7",
    y1: 10.331,
    x2: 2.388,
    transform: "translate(-13447.355 -5697.903)",
    fill: "none",
    stroke: "#000fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_8",
    "data-name": "Linha 8",
    y1: 9.593,
    transform: "translate(-13438.598 -5697.903)",
    fill: "none",
    stroke: "#000fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_9",
    "data-name": "Linha 9",
    x1: 3.184,
    y1: 10.331,
    transform: "translate(-13432.23 -5697.903)",
    fill: "none",
    stroke: "#000fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRevenda);
export default __webpack_public_path__ + "static/media/ic_revenda.710b9185267ebed72f3f8f61f11468d6.svg";
export { ForwardRef as ReactComponent };